import { match, P } from '@st/pattern'
import { routes } from '~/features/routes'
import {
  clientOrganizerMessageType,
  selCanSendClientOrganizer,
  type STSendClientOrganizerView
} from './st-send-client-organizer-module'
import { formatFolderEntityName } from './st-folder-display'

export function selSendClientOrganizerDialog(
  state: STSendClientOrganizerView,
  emailsManagedBy: 'stanfordtax' | 'karbon'
) {
  return match(state)
    .with({ status: P.union('loading', 'loadFailed') }, (state) => ({
      kind: state.status,
      title: sendDialogCopy(clientOrganizerMessageType(state.target)).title
    }))
    .with(
      { status: P.union('loaded', 'saving', 'savingAndClosing', 'sending', 'sent') },
      (state) =>
        ({
          kind: 'email',
          ...sendDialogCopy(clientOrganizerMessageType(state.target)),
          state,
          busy:
            state.status == 'saving' ||
            state.status == 'savingAndClosing' ||
            state.status == 'sending',
          readOnly:
            state.status == 'savingAndClosing' ||
            state.status == 'sending' ||
            state.status == 'sent',
          saveOnClose: state.status == 'loaded',
          canSend: selCanSendClientOrganizer(state),
          sendLabel: match(state.status)
            .with(P.union('saving', 'savingAndClosing'), () => 'Saving')
            .with('sending', () => 'Sending')
            .with('sent', () => 'Sent')
            .with('loaded', () => 'Send')
            .exhaustive(),
          showDeliveryReminder: state.target.type == 'taxReturnDelivery',
          karbonNotice: match(emailsManagedBy)
            .with(
              'karbon',
              () =>
                `StanfordTax will send ${formatFolderEntityName(
                  state.sendState.folder.entities,
                  'client'
                )} a direct link to their organizer. If you'd like to send them a link to their Karbon for Clients Portal instead, you can do so via Karbon.`
            )
            .with('stanfordtax', () => undefined)
            .exhaustive(),
          previewUrl: match(state.target.type)
            .with('taxReturnDelivery', () => undefined)
            .with(
              'clientOrganizerEmail',
              () =>
                routes.toPath({
                  name: 'organization_preview_questionnaire',
                  folderId: state.folderId,
                  organizationSlug: state.sendState.organizationSlug
                })!
            )
            .exhaustive(),
          emails: state.editedRecipients.map((recipient) => recipient.email)
        }) as const
    )
    .exhaustive()
}

function sendDialogCopy(messageType: string) {
  if (messageType == 'tax_return_delivery') {
    return {
      title: 'Deliver to client',
      subtitle:
        'The tax return will be added to the client’s organizer link, where they can review and sign it in a few easy steps.',
      copyLinkTip: 'Only the emails you add above will have access to review and sign.'
    }
  }

  return {
    title: 'Send client organizer',
    subtitle: undefined,
    copyLinkTip: 'Only the emails you add above will have access to enter the client organizer.'
  }
}
